import { ArslActionSetTlfViewMode, ArsListingState } from "../interface";

/**
 * Updates the listing TLF view mode setting.
 *
 * @param state - Current ARS listing state
 * @param action - Set-view-mode action containing the new mode
 * @returns Updated ARS listing state with the new view mode
 */
export const arsl_setTlfViewMode = <T>(
  state: ArsListingState<T>,
  action: ArslActionSetTlfViewMode,
): ArsListingState<T> => ({
  ...state,
  settings: {
    ...state.settings,
    tlfViewMode: action.tlfViewMode,
  },
});
